import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

// project imports - redux actions
import { SNACKBAR_OPEN } from 'store/actions';

// material-ui
import { MenuItem, Menu, Select, InputLabel, Typography, CircularProgress, Box, Button, Alert, AlertTitle } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMoreTwoTone';
import ChevronRightIcon from '@material-ui/icons/ChevronRightTwoTone';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import TreeItem from '@material-ui/lab/TreeItem';
import TreeView from '@material-ui/lab/TreeView';
import EditIcon from '@mui/icons-material/Edit';
import Grid from '@mui/material/Grid';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import IconButton from '@mui/material/IconButton';
import { FormControl } from '@mui/material';
import { FormattedMessage } from 'react-intl';

// project imports
import { getAvailableYears, getTreeForId } from 'services/geo-service';
import useAuth from 'hooks/useAuth';
import _ from 'lodash';
import { defaultSelectedYear, GEOLOCATION_WISE_YEAR_OPTIONS } from 'utils/pmp-constants';
import GeoTreeEditDeleteModal from './GeoTreeEditDeleteModal';

const options = [
    { icon: <AddIcon fontSize="small" />, localizedLabel: 'नवीन जोडा', label: 'add' },
    { icon: <EditIcon fontSize="small" />, localizedLabel: 'संपादित करा', label: 'edit' },
    { icon: <DeleteIcon fontSize="small" />, localizedLabel: 'काढा', label: 'delete' }
];

const geoLevelColors = {
    1: 'darkblue',
    2: '#3cb44b',
    3: 'dodgerblue',
    4: 'darkgoldenrod',
    5: 'darkcyan',
    6: 'coral',
    7: 'steelblue',
    8: '#f032e6',
    9: 'darkblue',
    10: 'darkgoldenrod',
    11: '#87b649'
};
export const RESTRICTED_LEVEL_FOR_ADD_GEOLOCATION = ['10', '11'];

const EditGeoTreeReport = (props) => {
    // const { skipLeaf, forAhawal, skipLevel } = props;

    const { user, token } = useAuth();
    const dispatch = useDispatch();

    // const theme = useTheme();
    const [loading, setLoading] = useState(false);
    const [tree, setTree] = useState({});
    // const [treeTable, setTreeTable] = useState([]);
    // const [tableColumns, setTableColumns] = useState([]);
    // const [showTable, setShowTable] = useState(false);
    const [year, setYear] = useState(defaultSelectedYear);

    const [modalOpen, setModalOpen] = useState(false);
    const [modalType, setModalType] = useState(null);
    const [selectedNode, setSelectedNode] = useState(null);
    const [anchorEl, setAnchorEl] = useState(null);
    const [showMenuOptions, setShowMenuOptions] = useState(options);
    const [listOfAvailableYears, setListOfAvailableYears] = useState(['2025-26']);
    const open = Boolean(anchorEl);

    // const shouldProceedChildren = (location) => {
    //     if (skipLeaf) {
    //         const leaf =
    //             location.children &&
    //             location.children.length > 0 &&
    //             (+location.children[0].level_id === 10 || +location.children[0].level_id === 11);
    //         if (leaf) {
    //             return false;
    //         }
    //         return true;
    //     }
    //     return location.children && location.children.length > 0;
    // };

    const updateTreeWithChildrenFor = useCallback((tree, locationId, response) => {
        if (tree.children) {
            const updated = tree.children.map((c) => {
                if (c.location_id === locationId) {
                    c = response;
                } else {
                    updateTreeWithChildrenFor(c, locationId, response);
                }
                return c;
            });
            tree.children = updated;
        }
    }, []);

    const extractGeoLocation = (data) => {
        const reportArray = [];
        reportArray.push({
            level: data?.level?.level_id?.toString(),
            name: data?.localized_name,
            type: data?.level?.localized_name,
            parent_name: data?.localized_name,
            level1: data?.localized_name,
            [data?.level?.localized_name]: data?.localized_name
        });

        data?.children?.map((item1) => {
            const location1 = {
                [data?.level?.localized_name]: data?.localized_name,
                name: item1?.localized_name,
                type: item1?.level?.localized_name,
                level: item1?.level?.level_id?.toString(),
                [item1?.level?.localized_name]: item1?.localized_name
            };
            reportArray.push(location1);

            item1?.children?.map((item2) => {
                const location2 = {
                    ...location1,
                    [item1?.level?.localized_name]: item1?.localized_name,
                    name: item2?.localized_name,
                    type: item2?.level?.localized_name,
                    [item2?.level?.localized_name]: item2?.localized_name,
                    level: item2?.level?.level_id?.toString()
                };
                reportArray.push(location2);
                item2?.children?.map((item3) => {
                    const location3 = {
                        ...location2,
                        [item2?.level?.localized_name]: item2?.localized_name,
                        name: item3?.localized_name,
                        type: item3?.level?.localized_name,
                        [item3?.level?.localized_name]: item3?.localized_name,
                        level: item3?.level?.level_id?.toString()
                    };
                    reportArray.push(location3);
                    item3?.children?.map((item4) => {
                        const location4 = {
                            ...location3,
                            [item3?.level?.localized_name]: item3?.localized_name,
                            name: item4?.localized_name,
                            type: item4?.level?.localized_name,
                            [item4?.level?.localized_name]: item4?.localized_name,
                            level: item4?.level?.level_id?.toString()
                        };
                        reportArray.push(location4);
                        item4?.children?.map((item5) => {
                            const location5 = {
                                ...location4,
                                [item4?.level?.localized_name]: item4?.localized_name,
                                name: item5?.localized_name,
                                type: item5?.level?.localized_name,
                                [item5?.level?.localized_name]: item5?.localized_name,
                                level: item5?.level?.level_id?.toString()
                            };
                            reportArray.push(location5);
                            item5?.children?.map((item6) => {
                                const location6 = {
                                    ...location5,
                                    [item5?.level?.localized_name]: item5?.localized_name,
                                    name: item6?.localized_name,
                                    type: item6?.level?.localized_name,
                                    [item6?.level?.localized_name]: item6?.localized_name,
                                    level: item6?.level?.level_id?.toString()
                                };
                                reportArray.push(location6);
                                item6?.children?.map((item7) => {
                                    const location7 = {
                                        ...location6,
                                        [item6?.level?.localized_name]: item6?.localized_name,
                                        name: item7?.localized_name,
                                        type: item7?.level?.localized_name,
                                        [item7?.level?.localized_name]: item7?.localized_name,
                                        level: item7?.level?.level_id?.toString()
                                    };
                                    reportArray.push(location7);
                                    item7?.children?.map((item8) => {
                                        const location8 = {
                                            ...location7,
                                            [item7?.level?.localized_name]: item7?.localized_name,
                                            name: item8?.localized_name,
                                            type: item8?.level?.localized_name,
                                            [item8?.level?.localized_name]: item8?.localized_name,
                                            level: item8?.level?.level_id?.toString()
                                        };
                                        reportArray.push(location8);
                                        item8?.children?.map((item9) => {
                                            const location9 = {
                                                ...location8,
                                                [item8?.level?.localized_name]: item8?.localized_name,
                                                name: item9?.localized_name,
                                                type: item9?.level?.localized_name,
                                                [item9?.level?.localized_name]: item9?.localized_name,
                                                level: item9?.level?.level_id?.toString()
                                            };
                                            reportArray.push(location9);
                                            item9?.children?.map((item10) => {
                                                const location10 = {
                                                    ...location9,
                                                    [item9?.level?.localized_name]: item9?.localized_name,
                                                    name: item10?.localized_name,
                                                    type: item10?.level?.localized_name,
                                                    [item10?.level?.localized_name]: item10?.localized_name,
                                                    level: item10?.level?.level_id?.toString()
                                                };
                                                reportArray.push(location10);
                                                item10?.children?.map((item11) => {
                                                    const location11 = {
                                                        ...location10,
                                                        [item10?.level?.localized_name]: item10?.localized_name,
                                                        name: item11?.localized_name,
                                                        type: item11?.level?.localized_name,
                                                        [item11?.level?.localized_name]: item11?.localized_name,
                                                        level: item11?.level?.level_id?.toString()
                                                    };
                                                    reportArray.push(location11);
                                                    item11?.children?.map((item12) => {
                                                        const location12 = {
                                                            ...location11,
                                                            [item11?.level?.localized_name]: item11?.localized_name,
                                                            name: item12?.localized_name,
                                                            type: item12?.level?.localized_name,
                                                            [item12?.level?.localized_name]: item12?.localized_name,
                                                            level: item12?.level?.level_id?.toString()
                                                        };
                                                        reportArray.push(location12);
                                                        return true;
                                                    });
                                                    return true;
                                                });
                                                return true;
                                            });
                                            return true;
                                        });
                                        return true;
                                    });
                                    return true;
                                });
                                return true;
                            });
                            return true;
                        });
                        return true;
                    });
                    return true;
                });
                return true;
            });

            return true;
        });

        // const columnNames = reportArray?.map((item) => {
        //     const tempName = {
        //         type: item?.type,
        //         level: parseInt(item?.level, 10)
        //     };
        //     return tempName;
        // });
        // const temp = _.orderBy(columnNames, ['level'], ['asc']);
        // const typeData = temp?.map((value) => value?.type);
        // setTableColumns(_.uniq(typeData));
        // const filteredData = reportArray.filter((item) => item.type.includes('गांव') || item.type.includes('वस्ती'));
        // setTreeTable(filteredData);
    };

    const getChildTreeFor = useCallback(
        (location, selectedYear) => {
            // const immediateParentToLeaves = ['शहरी नगर', 'मंडल', 'उपखंड नगर'];
            // if ((forAhawal && +location.level_id === 6) || +location.level_id === 7) {
            //     // Leaf for Ahwaal
            //     setTree(location);
            // }
            // if (forAhawal && parseInt(location.level_id, 10) >= 7) {
            //     return;
            // }
            // if (skipLeaf && immediateParentToLeaves.includes(location.name_suffix)) {
            //     return;
            // }
            // if (skipLevel && skipLevel?.includes(location.level_id)) {
            //     setTree(location);
            //     return;
            // }

            setLoading(true);
            getTreeForId(token, location.location_id, selectedYear)
                .then((response) => {
                    // Check if response indicates an error
                    if (response?.error) {
                        // Handle 404: No data for selected year
                        if (response.status === 404) {
                            setTree({});
                            dispatch({
                                type: SNACKBAR_OPEN,
                                open: true,
                                message: 'निवडलेल्या वर्षासाठी भौगोलिक रचना उपलब्ध नाही',
                                variant: 'alert',
                                alertSeverity: 'warning'
                            });
                        } else {
                            // Handle other errors (500, network, etc.)
                            setTree({});
                            dispatch({
                                type: SNACKBAR_OPEN,
                                open: true,
                                message: 'भौगोलिक रचना लोड करताना त्रुटी आली',
                                variant: 'alert',
                                alertSeverity: 'error'
                            });
                        }
                        setLoading(false);
                        return;
                    }

                    // Existing success logic
                    const treeClone = { ...response };
                    if (response.children && response.children.length > 0) {
                        //  recurssively check and update children at appropriate parentc
                        updateTreeWithChildrenFor(treeClone, location.location_id, response);
                        extractGeoLocation(treeClone);
                        setTree(treeClone);
                        // setShowTable(true);
                    } else {
                        setTree(response);
                    }
                    setLoading(false);
                })
                .catch((error) => {
                    setLoading(false);
                    setTree({});
                    dispatch({
                        type: SNACKBAR_OPEN,
                        open: true,
                        message: 'भौगोलिक रचना लोड करताना त्रुटी आली',
                        variant: 'alert',
                        alertSeverity: 'error'
                    });
                    console.error(error);
                });
        },
        [token, updateTreeWithChildrenFor, dispatch]
    );

    useEffect(() => {
        getChildTreeFor(user.profile.location, year);
    }, [getChildTreeFor, user, year]);

    // useEffect(() => {
    //     setLoading(true);
    //     getAvailableYears()
    //         .then((response) => {
    //             const { years } = response?.result ?? {};
    //             if (years?.length > 0) {
    //                 setListOfAvailableYears([...years]);
    //             } else {
    //                 setListOfAvailableYears([]);
    //             }
    //             setLoading(false);
    //         })
    //         .catch((error) => {
    //             setLoading(false);
    //             setListOfAvailableYears([]);
    //             console.error(error);
    //         });
    // }, []);

    const handleClickThreeDotButton = (e, node) => {
        e.stopPropagation();
        setSelectedNode(node);
        setAnchorEl(e.currentTarget);

        // handle menus list as per node level
        const filteredMenusList = options.filter((i) => {
            if (i.label === 'add' && RESTRICTED_LEVEL_FOR_ADD_GEOLOCATION.includes(node?.level?.level_id)) {
                return false;
            }
            return true;
        });
        setShowMenuOptions(filteredMenusList);
    };
    const handleCloseMenu = () => {
        setAnchorEl(null);
    };
    const handleLabelButtonChange = (e, type) => {
        e.stopPropagation();
        setModalType(type);
        setModalOpen(true);
        handleCloseMenu();
    };
    const handleModalClose = () => {
        setModalOpen(false);
        setModalType(null);
        setSelectedNode(null);
    };

    const renderLabel = (item) => (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'row'
            }}
        >
            <Typography
                onClick={(event) => {}}
                sx={{
                    color: item && item.level && item.level.level_id && geoLevelColors[item.level.level_id]
                }}
            >
                {item.localized_name} - {item.name_suffix}
            </Typography>
        </Box>
    );

    const renderTree = (nodes) => (
        // console.log(nodes, 'llkkk');
        <TreeItem
            sx={{ backgroundColor: '#fff' }}
            key={nodes.location_id}
            nodeId={nodes.location_id}
            label={
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        width: '100%',
                        pr: 1
                        // You can add hover effect for icon visibility:
                        // '&:hover .treeIconButtons': {}
                    }}
                >
                    <Typography variant="body2" sx={{ flexGrow: 1, minWidth: 0 }}>
                        {renderLabel(nodes)}
                    </Typography>
                    <Box className="treeIconButtons" sx={{ display: 'flex', transition: 'opacity 0.1s' }}>
                        <IconButton
                            aria-label="more"
                            id="long-button"
                            aria-controls={open ? 'long-menu' : undefined}
                            aria-expanded={open ? 'true' : undefined}
                            aria-haspopup="true"
                            onClick={(e) => {
                                handleClickThreeDotButton(e, nodes);
                            }}
                            size="large"
                        >
                            <MoreVertIcon fontSize="medium" />
                        </IconButton>

                        {/* add  */}
                        {/* don't show to level 10 and 11 */}
                        {/* {!RESTRICTED_LEVEL_FOR_ADD_GEOLOCATION.includes(nodes?.level?.level_id) && (
                            <Tooltip title="नवीन जोडा" placement="top">
                                <IconButton
                                    size="medium"
                                    onClick={(event) => {
                                        event.stopPropagation();
                                        handleLabelButtonChange(nodes, 'add');
                                    }}
                                >
                                    <AddIcon fontSize="small" />
                                </IconButton>
                            </Tooltip>
                        )} */}

                        {/* edit */}
                        {/* <Tooltip title="संपादित करा" placement="top">
                            <IconButton
                                size="medium"
                                onClick={(event) => {
                                    event.stopPropagation();
                                    handleLabelButtonChange(nodes, 'edit');
                                }}
                            >
                                <EditIcon fontSize="small" />
                            </IconButton>
                        </Tooltip> */}

                        {/* delete */}
                        {/* <Tooltip title="हटवा" placement="top">
                            <IconButton
                                size="medium"
                                onClick={(event) => {
                                    event.stopPropagation();
                                    handleLabelButtonChange(nodes, 'delete');
                                }}
                            >
                                <DeleteIcon fontSize="small" />
                            </IconButton>
                        </Tooltip> */}
                    </Box>
                </Box>
            }
        >
            {Array.isArray(nodes.children) ? nodes.children.map((node) => renderTree(node)) : null}
        </TreeItem>
    );
    // const options = {
    //     selectableRows: 'none',
    //     download: false,
    //     filter: true,
    //     print: false,
    //     pagination: true,
    //     rowsPerPageOptions: [10, 20, 50, 100, 150, 200],
    //     search: true,
    //     viewColumns: false,
    //     sort: false,
    //     sortThirdClickReset: true,
    //     fixedHeader: true,
    //     fixedSelectColumn: true,
    //     responsive: 'scroll',
    //     tableBodyHeight: '100%',
    //     textLabels: {
    //         body: {
    //             noMatch: 'माहिती उपलब्ध नाही'
    //         }
    //     }
    // };

    // const handleYearChange = (event) => {
    //     setYear(event.target.value);
    //     // setRows([]);
    // };

    // console.log('selected year: ', year);

    const handleYearChange = (event) => {
        setYear(event.target.value);
        // setRows([]);
    };

    return (
        <>
            {/* <Typography color="error">
                <FormattedMessage id="bhaugolik-rachana-select" />
            </Typography> */}
            {loading && (
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <CircularProgress color="primary" size={20} />
                    <Typography color="primary"> &nbsp;कृपया प्रतीक्षा करा!</Typography>
                </Box>
            )}

            {/* infor message */}

            {tree && !loading && Object.keys(tree).length > 0 && (
                <Grid item xs={12} sx={{ marginBottom: '20px' }}>
                    <Alert severity="info" variant="filled" sx={{ color: '#fff' }}>
                        <AlertTitle sx={{ color: '#fff' }}>
                            कृपया तुम्हाला ज्या भौगोलिक स्थानाचे संपादन करायचे आहे किंवा हटवायचे आहे किंवा जोडायचे आहे ते निवडा!
                        </AlertTitle>
                    </Alert>
                </Grid>
            )}
            <FormControl sx={{ marginBottom: '10px', width: '20%' }}>
                <InputLabel id="year-select">
                    <FormattedMessage id="year" />
                </InputLabel>
                <Select
                    id="year"
                    fullWidth
                    name="year"
                    label="year"
                    value={year || ''}
                    onChange={handleYearChange}
                    displayEmpty
                    size="small"
                    inputProps={{ 'aria-label': 'Without label' }}
                >
                    {GEOLOCATION_WISE_YEAR_OPTIONS?.map((year, index) => (
                        <MenuItem key={index} value={year}>
                            {year}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>

            {!loading && (!tree || Object.keys(tree).length === 0) && (
                <Box
                    sx={{
                        textAlign: 'center',
                        py: 8,
                        color: 'text.secondary'
                    }}
                >
                    <Typography variant="h4" gutterBottom>
                        कोणतीही डेटा उपलब्ध नाही
                    </Typography>
                    <Typography variant="body1">निवडलेल्या वर्षासाठी भौगोलिक रचना आढळली नाही</Typography>
                </Box>
            )}

            {tree && !loading && Object.keys(tree).length > 0 && (
                <>
                    <TreeView
                        aria-label="rich object"
                        defaultCollapseIcon={<ExpandMoreIcon />}
                        defaultExpanded={['root']}
                        defaultExpandIcon={<ChevronRightIcon onClick={() => console.log('Expand Clicked')} />}
                        // sx={{ height: 110, flexGrow: 1, maxWidth: 400, overflowY: 'auto' }}
                    >
                        {renderTree(tree)}
                    </TreeView>
                </>
            )}

            <GeoTreeEditDeleteModal
                loadCurrentGeoTree={getChildTreeFor}
                selectedYear={year}
                open={modalOpen}
                onClose={handleModalClose}
                type={modalType}
                node={selectedNode}
                restrictedLevels={RESTRICTED_LEVEL_FOR_ADD_GEOLOCATION}
            />

            <Menu
                id="long-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleCloseMenu}
                slotProps={{
                    list: {
                        'aria-labelledby': 'long-button'
                    }
                }}
            >
                {showMenuOptions.map((option) => (
                    <MenuItem
                        key={option.localizedLabel}
                        onClick={(e) => {
                            handleLabelButtonChange(e, option.label);
                        }}
                    >
                        <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', justifyContent: 'flex-start' }}>
                            {option.icon}
                            <span style={{ fontSize: '16px' }}>{option.localizedLabel}</span>
                        </Box>
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
};

export default EditGeoTreeReport;
